import clsx from "clsx";
import { ForwardedRef } from "react";
import { ChevronUp } from "react-feather";
import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../../types";
import { forwardRefWithGeneric } from "../../utils";
import CardHeader, { CardHeaderProps } from "../cardHeader";
import { useCardContext } from "./context";

const CollapsibleCardHeader = <T extends React.ElementType = "div">(
  props: PropsWithAs<CardHeaderProps, T>,
  ref: ForwardedRef<any>
) => {
  const { children, className } = props;
  const { collapsed, setCollapsed } = useCardContext();

  return (
    <CardHeader
      {...props}
      ref={ref}
      onClick={() => setCollapsed(!collapsed)}
      className={twMerge(
        "flex justify-between cursor-pointer select-none",
        className
      )}
    >
      {children}
      <ChevronUp
        className={clsx("transition-transform", {
          "rotate-180": collapsed,
        })}
      />
    </CardHeader>
  );
};

export default forwardRefWithGeneric(CollapsibleCardHeader);
